module.exports = __webpack_public_path__ + "img/letter-y.cefc773d.svg";